export default __webpack_public_path__ + "static/media/cafgu.6ad67510.png";